export enum ExternalListStatus {
  Pending = 1,
  Processing,
  Failed,
  Ready,
}
